module.exports = __webpack_public_path__ + "static/img/aa-11.c8534c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aa-11.png
// module id = v21g
// module chunks = 1